// Dictionnaire français — espace client et pages légales uniquement.
//
// La landing n'est plus traduite : ses clés retombent sur l'anglais par la
// fusion profonde de lib/i18n.js.
import app from './app'
import legal from './legal'

const fr = { ...app, legal }

export default fr
